var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4058 13.7058C10.3936 11.7186 13.0893 10.6022 15.9 10.6022C18.7107 10.6022 21.4064 11.7186 23.3942 13.7058L26.5 16.8089L29.6058 13.7058C30.5836 12.6934 31.7533 11.8858 33.0465 11.3303C34.3397 10.7748 35.7307 10.4824 37.1381 10.4701C38.5456 10.4579 39.9414 10.7261 41.2441 11.2591C42.5468 11.792 43.7303 12.5791 44.7256 13.5744C45.7208 14.5697 46.5079 15.7532 47.0409 17.0559C47.5739 18.3586 47.8421 19.7544 47.8298 21.1618C47.8176 22.5693 47.5252 23.9602 46.9697 25.2535C46.4141 26.5467 45.6066 27.7164 44.5942 28.6942L26.5 46.791L8.4058 28.6942C6.4186 26.7064 5.30226 24.0107 5.30226 21.2C5.30226 18.3892 6.4186 15.6936 8.4058 13.7058V13.7058Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5dde5746772b27af5444a3b3a0f2148d.svg";
export { ForwardRef as ReactComponent };